import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackBoardTemplatesOpened.meta';

export type TrackBoardTemplatesOpenedParams = {
  type: string;
};

export const useTrackBoardTemplatesOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackBoardTemplatesOpened = useCallback(
    (params: TrackBoardTemplatesOpenedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackBoardTemplatesOpened };
};
